(function () {
  const modal = document.querySelector('[data-tis-how-modal]');
  if (!modal || typeof modal.showModal !== 'function') return;
  let opener = null;
  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-tis-how-modal-open]');
    if (openButton) {
      event.preventDefault();
      opener = openButton;
      modal.showModal();
      document.body.classList.add('tis-how-modal-open');
      const closeButton = modal.querySelector('[data-tis-how-modal-close]');
      if (closeButton) closeButton.focus();
      return;
    }
    const closeButton = event.target.closest('[data-tis-how-modal-close]');
    if (closeButton && modal.open) {
      modal.close();
      document.body.classList.remove('tis-how-modal-open');
    }
  });
  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.close();
      document.body.classList.remove('tis-how-modal-open');
    }
  });
  modal.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.open) {
      modal.close();
      document.body.classList.remove('tis-how-modal-open');
    }
  });
  modal.addEventListener('close', function () {
    document.body.classList.remove('tis-how-modal-open');
    if (opener) opener.focus();
  });
})();
